<template>
  <button class="btn" @click="click()">
    <img
      v-show="iconLeft"
      class="icon-left"
      :src="iconLeft"
      alt="icon"
    >
    <span>
      <slot />
    </span>
    <img
      v-show="iconRight"
      class="icon-right"
      :src="iconRight"
      alt="icon"
    >
  </button>
</template>

<script>
export default {
  name: 'Button',
  props: {
    iconLeft: {
      type: String,
    },
    iconRight: {
      type: String,
    },
  },
  methods: {
    click() {
      this.$emit('click');
    },
  },
};
</script>
